import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/device/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/device/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/device/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/device/detail',
        method: 'post',
        data
    })
}
// 分页查询
export const auditDevice = (data) => {
  return axios({
    url: '/device/report/'+data,
    method: 'post'
  })
}

// 绑定
export const devassign = (data) => {
  return axios({
    url: '/device/devassign',
    method: 'post',
    data:data
  })
}
// 解绑
export const devRembinding = (data) => {
  return axios({
    url: '/device/devRembinding/'+data,
    method: 'post'
  })
}
// 解除备案
export const removeRecord = (data) => {
  return axios({
    url: '/device/removeRecord/'+data,
    method: 'post'
  })
}
// 获取终端信息
export const getDevice = (data) => {
  return axios({
    url: '/device/getDevice',
    method: 'post',
    data
  })
}

/**
 * 导入excel
 */
 export const importDevice= (data) => {
  return axios({
    url: '/device/import',
    method: 'post',
    data
  })
}
/**
 * 导出 Excel
 * @param schoolId 驾校列表
 * @param licnum 车牌号码
 * @param termType 终端类型
 * @param status 备案状态
 * @param online 是否在线
 * @param trainStatus 培训状态
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702585
 */
export const exportExcel = data => {
  return axios({
    url: '/device/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/device/device.js